import config_prod from './ConfigProd'
import config_dev from './ConfigDev'

const override = (value, fallback) => typeof value === 'undefined' ? fallback : value

const withEnvOverrides = (config) => ({
  ...config,
  apiEndpoint: override(process.env.REACT_APP_API_ENDPOINT, config.apiEndpoint),
  imageUrl: override(process.env.REACT_APP_IMAGE_URL, config.imageUrl),
  s3Url: override(process.env.REACT_APP_S3_URL, config.s3Url),
  siteUrl: override(process.env.REACT_APP_SITE_URL, config.siteUrl),
  env: override(process.env.REACT_APP_STAGE, config.env)
})

const ConfigResolver = {
  config: () => {
    let stageName = process.env.REACT_APP_STAGE || 'production'
    const config = ['dev', 'development'].includes(process.env.NODE_ENV) || stageName === 'dev' ? config_dev : config_prod
    return withEnvOverrides(config)
  }
}

export default ConfigResolver
